// hook/useShadeSearch.js
import { useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { getShadeNumberList } from "../redux/reduxApi/admin/ShadeReduxApi";

const useShadeSearch = (options = {}) => {
  const { 
    pageSize = 30,
    searchField = "shadeNo",
    categoryOptions = []
  } = options;

  const dispatch = useDispatch();
  const [totalCount, setTotalCount] = useState(0);

  // Format shade options
  const formatShadeOptions = useCallback((shades) => {
    const categoryMap = new Map(
      categoryOptions.map((category) => [String(category.value), category.label])
    );

    return shades.map((shade) => ({
      label: [
        shade.shadeNo,
        shade.shadeCategory?.name ||
          shade.shadeCategory?.label ||
          categoryMap.get(String(shade.shadeCategory)) ||
          "",
      ].filter(Boolean).join(" - "),
      value: shade.ROWID,
      shadeCategory: shade.shadeCategory
    }));
  }, [categoryOptions]);

  // Load shades with pagination and search
  const loadShades = useCallback(async (search, loadedOptions, { page = 1 }) => {
    const searchCriteria = [];

    // Build search criteria based on search term
    if (search && search.trim()) {
      searchCriteria.push({
        field: searchField,
        operation: "contains",
        value: search.trim()
      });
    }

    try {
      const response = await dispatch(getShadeNumberList({
        page: page,
        size: pageSize,
        search: searchCriteria
      }));

      const shades = response.payload?.data?.shades || [];
      const total = response.payload?.data?.total || 0;
      
      setTotalCount(total);
      
      const options = formatShadeOptions(shades);
      
      return {
        options: options,
        hasMore: shades.length === pageSize,
        additional: {
          page: page + 1
        }
      };
    } catch (error) {
      console.error("Error loading shades:", error);
      return {
        options: [],
        hasMore: false,
        additional: { page }
      };
    }
  }, [dispatch, pageSize, searchField, formatShadeOptions]);

  return {
    loadShades,
    totalCount,
  };
};

export default useShadeSearch;
